<template>
  <div class="rightContent" v-if="(items.discountTypes&&items.endTime || $store.state.memberLevel&&items[getMemberLevel($store.state.memberLevel).memberLevel]&&items.memberEndTime)">
    <span v-if="$store.state.memberLevel&&items[getMemberLevel($store.state.memberLevel).memberLevel]">{{getMemberLevel($store.state.memberLevel).name}}：￥<span>{{items[getMemberLevel($store.state.memberLevel).memberLevel]}}</span></span>
    <span v-if="items.discountTypes=='seckill'">秒杀特惠 ：￥<span>{{items.priceType}}</span></span>
    <span v-if="items.discountTypes=='change'">换购特惠 ：￥<span>{{items.changeData}}</span></span>
    <!-- 没件有赠 -->
    <span v-if="items.discountTypes=='spell'&&items.spellText.indexOf('件')==-1&&items.spellData.indexOf('赠')>-1">满￥<span>{{items.spellText}}</span> ：赠<span>{{items.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
    <!-- 有件没赠 -->
    <span v-if="items.discountTypes=='spell'&&items.spellText.indexOf('件')>-1&&items.spellData.indexOf('赠')==-1">满<span>{{items.spellText.match(/\d+(\.\d+)?/g)[0]}}</span>件 ：￥<span>{{items.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
    <!-- 没件没赠 -->
    <span v-if="items.discountTypes=='spell'&&items.spellText.indexOf('件')==-1&&items.spellData.indexOf('赠')==-1">满￥<span>{{items.spellText.match(/\d+(\.\d+)?/g)[0]}}</span> ：￥<span>{{items.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
    <!-- 有件有赠 -->
    <span v-if="items.discountTypes=='spell'&&items.spellText.indexOf('件')>-1&&items.spellData.indexOf('赠')>-1">满<span>{{items.spellText.match(/\d+(\.\d+)?/g)[0]}}</span>件 ：赠￥<span>{{items.spellData.match(/\d+(\.\d+)?/g)[0]}}</span></span>
    <!-- 有件 -->
    <span v-if="items.discountTypes=='give'&&items.giveText.indexOf('件')>-1">满<span>{{items.giveText.match(/\d+(\.\d+)?/g)[0]}}</span>件 ：用￥<span>{{items.giveData}}</span></span>
    <!-- 无件 -->
    <span v-if="items.discountTypes=='give'&&items.giveText.indexOf('件')==-1">满￥<span>{{items.giveText}}</span> ：用￥<span>{{items.giveData}}</span></span>
  </div>
</template>
<script>
export default {
  name: 'preferential',
  props:{
    items:Object
  }
}
</script>
<style lang="scss" scoped>
  .rightContent{
    border: 1px solid #fcb7b8;
    background-color: #fee5e5;
    border-radius: 4px;
    padding: 0 10px;
    line-height: 20px;
    margin: 3px 10px 3px 0;
    cursor: pointer;
    &:hover{
        background-color: #fef1f1;
    }
    span{
      font-size: 12px;
      font-weight: 600;
      color: #f40002;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/preferential.vue